import { useCallback } from 'react'
import { NotificationData, notifications } from '@mantine/notifications'
import classes from './notification.module.css'
import { IconCheck, IconExclamationMark, IconInfoCircle, IconCircleMinus } from '@tabler/icons-react'

export default function useNotifications() {
    return useCallback(
        (notification: NotificationData) =>
            notifications.show({
                ...notification,
                classNames: classes,
                icon:
                    notification.color === 'green' ? (
                        <IconCheck />
                    ) : notification.color === 'red' ? (
                        <IconExclamationMark />
                    ) : notification.color === 'black' ? (
                        <IconInfoCircle />
                    ) : notification.color === 'gray' ? (
                        <IconCircleMinus />
                    ) : undefined,
            }),
        [],
    )
}
